export const config = {
  showArtikelNumberField: false,
  showBrandField: true,
  tenantId: 'REPAIR-REBELS'
}